import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  AppBar,
  Divider,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Folder as FolderIcon,
  SmartToy as AgentIcon,
  PlayArrow as TestIcon,
  Assessment as ReportIcon,
  QuestionAnswer as QuestionIcon,
} from '@mui/icons-material';

const drawerWidth = 240;

const menuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
  { text: 'Fontes de Dados', icon: <FolderIcon />, path: '/file-sources' },
  { text: 'Bases de Perguntas', icon: <QuestionIcon />, path: '/question-bases' },
  { text: 'Agentes', icon: <AgentIcon />, path: '/agents' },
  { text: 'Testes', icon: <TestIcon />, path: '/test-runs' },
];

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          <ReportIcon sx={{ mr: 2 }} />
          <Typography variant="h6" noWrap component="div">
            JBT Agent Evaluation
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        <Toolbar />
        <Divider />
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                selected={location.pathname.startsWith(item.path)}
                onClick={() => navigate(item.path)}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}

export default Sidebar;
